// Toast Notification (Schema theme settings)

class ToastNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = this.querySelector('.toast-notification__content');
    this.messageElement = this.querySelector('.toast-notification__message');
    this.closeButton = this.querySelector('.toast-notification__close');
    this.timeoutId = null;

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.hide.bind(this));
    }

    // Subscribe to cart updates
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.subscribeToCartUpdates());
    } else {
      this.subscribeToCartUpdates();
    }
  }

  subscribeToCartUpdates() {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cartData = event.cartData;
        const previousItemCount = event.previousItemCount;
        
        let message = '';

        if (event.toastMessage) {
            message = event.toastMessage;
        } else if (cartData) {
            if (event.source === 'product-form') {
                 message = 'Item added successfully';
            }
            else if (event.source === 'cart-items' || event.source === 'cart-drawer') {
               if (event.variantId && event.quantity === 0) {
                   message = 'Item removed successfully';
               } else {
                   message = 'Cart updated successfully';
               }
            }
        }

        if (message) {
            const type = event.toastType || (event.isError ? 'error' : 'success');
            if (type === 'success') {
                this._delayTimeout = setTimeout(() => this.show(message, type), 500);
            } else {
                this.show(message, type);
            }
        }
    });
  }

  show(message, type = 'success') {
    if (type !== 'success' && this._delayTimeout) {
      clearTimeout(this._delayTimeout);
      this._delayTimeout = null;
    }
    this.messageElement.textContent = message;
    this.classList.toggle('toast-notification--error', type === 'error');
    this.classList.toggle('toast-notification--warning', type === 'warning');
    
    // Restart Logic:
    // If already active, we want to restart the animation.
    if (this.classList.contains('active')) {
        this.classList.remove('active');
        void this.offsetWidth;
        
        // Clear existing timeout so it doesn't hide prematurely
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    this.classList.remove('hidden');
    this.classList.add('active');

    // Auto-hide after 5 seconds
    this.timeoutId = setTimeout(() => {
      this.hide();
    }, 3000);
  }

  hide() {
    this.classList.remove('active');
    this._hideTimeout = setTimeout(() => {
        this.classList.add('hidden');
    }, 300);
  }

  disconnectedCallback() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = null;
    }
    if (this._delayTimeout) {
      clearTimeout(this._delayTimeout);
      this._delayTimeout = null;
    }
  }
}

customElements.define('toast-notification', ToastNotification);
